import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=4e178e20&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e178e20"]])

export default __exports__